import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import GeneralDialog from '../../../../shared/general-dialog';
import { useState } from 'react';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface OrganizationEditDialogProps {
  openOrganizationDialog: boolean;
  setOpenOrganizationDialog: (value: boolean) => void;
  clickedIndex: number;
  setValue: UseFormSetValue<UserFormData>;
  disabled: boolean;
  getValues: UseFormGetValues<UserFormData>;
}

export default function OrganizationEditDialog({
  openOrganizationDialog,
  setOpenOrganizationDialog,
  clickedIndex,
  setValue,
  disabled,
  getValues,
}: OrganizationEditDialogProps) {
  const [name, setName] = useState(() =>
    getValues(`organizations.${clickedIndex}.name`)
  );
  const [title, setTitle] = useState(() =>
    getValues(`organizations.${clickedIndex}.title`)
  );
  const [department, setDepartment] = useState(() =>
    getValues(`organizations.${clickedIndex}.department`)
  );
  const [location, setLocation] = useState(() =>
    getValues(`organizations.${clickedIndex}.location`)
  );
  const [symbol, setSymbol] = useState(() =>
    getValues(`organizations.${clickedIndex}.symbol`)
  );
  const [costCenter, setCostCenter] = useState(() =>
    getValues(`organizations.${clickedIndex}.costCenter`)
  );
  const [description, setDescription] = useState(() =>
    getValues(`organizations.${clickedIndex}.description`)
  );

  const formValuesHaveChanged =
    name !== getValues(`organizations.${clickedIndex}.name`) ||
    title !== getValues(`organizations.${clickedIndex}.title`) ||
    department !== getValues(`organizations.${clickedIndex}.department`) ||
    location !== getValues(`organizations.${clickedIndex}.location`) ||
    symbol !== getValues(`organizations.${clickedIndex}.symbol`) ||
    costCenter !== getValues(`organizations.${clickedIndex}.costCenter`) ||
    description !== getValues(`organizations.${clickedIndex}.description`);

  return (
    <GeneralDialog
      open={openOrganizationDialog}
      handleClose={() => {
        setOpenOrganizationDialog(false);
      }}
      title={'Edit Organization'}
      dialogContent={
        <Stack sx={{ px: 1 }} gap={4}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Organization Name"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Employee Title"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={department}
                onChange={(e) => {
                  setDepartment(e.target.value);
                }}
                label="Employee Department"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
                label="Location"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={symbol}
                onChange={(e) => {
                  setSymbol(e.target.value);
                }}
                label="Stock Symbol"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={costCenter}
                onChange={(e) => {
                  setCostCenter(e.target.value);
                }}
                label="Cost Center"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                label="Type of Employee"
                fullWidth
              />
            </Grid>
          </Grid>
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: () => {
          if (formValuesHaveChanged) {
            setValue(`organizations.${clickedIndex}.name`, name, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.title`, title, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.department`, department, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.location`, location, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.symbol`, symbol, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.costCenter`, costCenter, {
              shouldDirty: true,
            });
            setValue(`organizations.${clickedIndex}.description`, description, {
              shouldDirty: true,
            });
          }

          setOpenOrganizationDialog(false);
        },
        disabled: !formValuesHaveChanged,
        title: 'Update',
      }}
    />
  );
}
